// extracted by mini-css-extract-plugin
export default {"defaultpage":"DefaultPage_defaultpage__frGVx","page":"DefaultPage_page__muTwH","children":"DefaultPage_children__hDtnk"};